import { useMutation } from "@tanstack/react-query";

import { ExportReportParams } from "api";
import { useDocumentService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

export const mapApiExportReportParams = (
  csvParam: DownloadCsvParams
): ExportReportParams => {
  return {
    ObjectType: csvParam.objectType,
    RecipientEmails: csvParam.recipientEmails,
    Message: csvParam.message,
    CardCodes: csvParam.cardCodes,
    CreateDateStart: csvParam.createDateStartDate,
    CreateDateEnd: csvParam.createDateEndDate,
    ContractDateStart: csvParam.contractDateStartDate,
    ContractDateEnd: csvParam.contractDateEndDate,
    StartShipDateStart: csvParam.startShipStartDate,
    StartShipDateEnd: csvParam.startShipEndDate,
    EndShipDateStart: csvParam.endShipStartDate,
    EndShipDateEnd: csvParam.endShipEndDate,
    DocDateStart: csvParam.invoiceDateStartDate,
    DocDateEnd: csvParam.invoiceDateEndDate,
    // dueDateStartDate is for Due Date filter on Invoices tab, shipDateStartDate is for the Ship Date filter on Deliveries tab
    DocDueDateStart: csvParam.dueDateStartDate ?? csvParam.shipDateStartDate,
    // dueDateEndDate is for Due Date filter on Invoices tab, shipDateEndDate is for the Ship Date filter on Deliveries tab
    DocDueDateEnd: csvParam.dueDateEndDate ?? csvParam.shipDateEndDate,
    // shipDateEndDate is for the Ship Date filter on Deliveries tab, dueDateEndDate is for Due Date filter on Invoices tab
    ShipDateStart: csvParam.shipDateStartDate ?? csvParam.dueDateStartDate,
    // shipDateEndDate is for the Ship Date filter on Deliveries tab, dueDateEndDate is for Due Date filter on Invoices tab
    ShipDateEnd: csvParam.shipDateEndDate ?? csvParam.dueDateEndDate,
    SearchString: csvParam.searchString,
    ProductCodes: csvParam.product,
    WarehouseCodes: csvParam.shipFrom,
    ShipToCodes: csvParam.shipTo,
    SalesTerms: csvParam.salesTerms,
    Modes: csvParam.mode,
    StatusCodes: csvParam.status,
  };
};

const useGetFormattedCsv = (cardCodes: string[]) => {
  const documentService = useDocumentService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useMutation({
    mutationKey: ["download-csv-file", cardCodes],
    mutationFn: (exportCsvParams: DownloadCsvParams) => {
      const eventId = trackQuery({
        endpoint: "/api/Report/Download",
      });
      return documentService
        .getFormattedCsv(mapApiExportReportParams(exportCsvParams))
        .catch((err) => {
          trackQueryError({ message: err.message }, eventId);
          throw err;
        });
    },
  });
};

export default useGetFormattedCsv;
